export enum AlertState {
    SCADUTO = 1,
    IN_SCADENZA,
    PENDENTE,
}

export enum TabTitle {
    "Stato ok",
    "Alert scaduti",
    "Alert in scadenza",
}

export enum CellType {
    NE, //ne
    AC, //acquisto
    VE, //vendita
    RE, //results
}

export enum PianoFatturazioneStato {
    PIANIFICATO,
    DA_FATTURARE,
    FATTURATO,
}

export enum QualificheFornitore {
    DA_VERIFICARE,
    NON_QUALIFICATO,
    QUALIFICATO,
    SOSPESO,
}

export enum Rubrica {
    CLIENTI,
    CONTATTI,
}

export enum TableOrder {
    NONE,
    ASC,
    DESC,
}

export enum TipoNotifica {
    AZIENDA_CREATA = 0,
    AZIENDA_APPROVATA = 1,
    AZIENDA_RIFIUTATA = 2,
    FORNITORE_CREATO = 3,
}

export interface TableColDef {
    prop: string;
    name?: string;
    orderable?: true;
    class?: any;
    order?: TableOrder;
    width?: number;
}

export interface TableCellDef {
    content?: string;
    context?: any;
}

export interface TableRowDef {
    cells: TableCellDef[];
    context?: any;
}

export interface Paths {
    title?: string;
    icon?: string;
    name: string;
}

export enum LabelStati {
    NEU,
    PRO,
    PRE,
    BRI,
    ATP,
    ATT,
    X,
}

export enum ColoriStati {
    neu,
    pro,
    pre,
    bri,
    atp,
    att,
    nin,
}

export enum NomiStato {
    "Neutro",
    "Prospect",
    "Presentazione",
    "Brief",
    "Progetto attivo",
    "Cliente attivo",
    "Non interessato",
}

export enum TipoRigaPreventivo {
    OFFERTA,
    DESCRIZIONE,
    OPZIONALE,
}

export enum StatiSottoprogetto {
    OFFERTA = "OFFERTA",
    OFFERTA_INVIATA = "OFFERTA_IN",
    OFFERTA_NON_CONFERMATA = "OFFERTA_NC",
    OFFERTA_NON_CONFERMATA_DA_CHIUDERE = "OFF_NC_DC",
    RICHIESTA_APERTURA = "RICH_APERT",
    APERTO = "APERTO",
    CONSUNTIVAZIONE_INVIATA = "CI",
    CHIUSURA_DA_ODA = "C_ODA",
    CHIUSO_CONTABILMENTE = "CHI CONTAB",
    ERRATA = "ERRATA",
}

export interface CercaModalData {
    text?: string;
    settori?: number[];
    responsabili?: number[];
    presentazioni?: number[];
    accounts?: number[];
    bu?: number[];
    stato?: number;
    contatti?: string[];
    ultimo_contatto_a?: string | null;
    ultimo_contatto_da?: string | null;
}

export const reverseMode = new Map<string, StatiSottoprogetto>();
Object.keys(StatiSottoprogetto).forEach((mode: any) => {
    // @ts-ignore
    const modeValue: string = StatiSottoprogetto[mode as any];
    reverseMode.set(modeValue, mode);
});

export enum StatiSottoprogettoToLabel {
    OFFERTA = "Offerta",
    OFFERTA_INVIATA = "Offerta inviata",
    OFFERTA_NON_CONFERMATA = "Offerta non confermata",
    OFFERTA_NON_CONFERMATA_DA_CHIUDERE = "Offerta non confermata da chiudere",
    RICHIESTA_APERTURA = "Richiesta apertura",
    APERTO = "Aperto",
    CONSUNTIVAZIONE_INVIATA = "Consuntivazione inviata",
    CHIUSURA_DA_ODA = "Chiusura da oda",
    CHIUSO_CONTABILMENTE = "Chiuso contabilmente",
    ERRATA = "Errata",
}

import { Loader } from "@googlemaps/js-api-loader";

const gMapLoader = new Loader({
    apiKey: "AIzaSyAPap5qxsUHzO-tWNdNTkXhT9R53oP-VY0",
    version: "weekly",
    language: "it",
});

export default gMapLoader;
